<template>
  <v-card flat>
    <order-item id="adjustment" type="adjustment" :isList="true" v-if="renderScrollList" :payload="scrollListPayload"></order-item>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { hostAppApi } from '@/plugins/axios_settings'
export default {
  data () {
    return {
      listOfOrders: [],
      loading: false,
      scrollListPayload: {
        width: 65,
        loading: false,
        module: '',
        moduleTitle: 'message.whsDashboard.adjustmentOrders',
        showScanCode: true,
        list: [],
        totalCount: 0,
        items: [{
          value: 'number',
          class: 'pa-0 my-auto',
          cols: '3',
          spanClass: 'body-2',
          isParagraph: true
        }, {
          value: '',
          cols: '7',
          class: 'pa-0',
          rowClass: 'mt-2',
          subItems: [{
            value: 'warehousename',
            class: 'pa-0',
            cols: '12'
          }]
        }],
        hasDelete: false,
        page: -1,
        previousSearch: '',
        recordsPerPage: 15
      },
      page: 1,
      totalCount: 0,
      totalDbData: 0,
      scanNumber: '',
      perPage: 6,
      hasNoNext: true,
      /* Scanner field */
      scannerPayload: {
        placeholder: 'message.whsDashboard.scanText',
        change: this.getRespectiveAdjustmentOrder,
        attrRef: 'scannerFieldFocus',
        attrId: 'scannerField'
      },
      scannerFieldLoading: false,
      renderScrollList: false,
      listMaxCallLoaded: false
    }
  },
  components: {
    'order-item': () => import('@/components/Order/NewOrederItem.vue')
  },
  mounted () {
    this.getOrders()
    this.$eventBus.$on('loadList', (data) => {
      this.getOrders(data)
    })
  },
  watch: {
    page (val) {
      this.getOrders()
    }
  },
  computed: {
    ...mapGetters(['getHostRefApi', 'userId'])
  },
  methods: {
    getOrders (search) {
      if (search && (search !== this.scrollListPayload.previousSearch)) {
        this.scrollListPayload = { ...this.scrollListPayload, ...{ list: [], page: -1, previousSearch: search, totalCount: 0 } }
        this.listMaxCallLoaded = false
      }
      if (!search && this.scrollListPayload.previousSearch) {
        this.scrollListPayload = { ...this.scrollListPayload, ...{ list: [], page: -1, previousSearch: '', totalCount: 0 } }
        this.listMaxCallLoaded = false
      }
      if (this.listMaxCallLoaded) return
      this.scrollListPayload.loading = true
      this.scrollListPayload.module = this.MODULE
      this.scrollListPayload.page++
      const model = {
        page: this.scrollListPayload.page + 1,
        rowsperpage: this.scrollListPayload.recordsPerPage
      }
      let url = `${this.getHostRefApi}warehouseorders/get_adjustment_orders?user_id=${this.userId}`
      if (!this.scrollListPayload.showScanCode && search) url += `&search=${search}`
      hostAppApi.post(url, model)
        .then((response) => {
          if (response.data) {
            this.scrollListPayload.total = response.data.total
            this.scrollListPayload.list = [...this.scrollListPayload.list, ...response.data.items]
            if (this.scrollListPayload.totalCount === this.scrollListPayload.list.length) this.listMaxCallLoaded = true
          }
        })
        .finally(() => {
          this.loading = false
          this.scrollListPayload.loading = false
          if (this.scrollListPayload.page === 0) this.renderScrollList = true
        })
    },
    previousList () {
      this.page--
      this.checkIsNextEnabled()
    },
    nextList () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.page++
        this.hasNoNext = false
      }
    },
    checkIsNextEnabled () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.hasNoNext = false
      }
    },
    getRespectiveAdjustmentOrder () {
      if (this.scanNumber) {
        this.scannerFieldLoading = true
        hostAppApi.get(`${this.getHostRefApi}warehouseorders/get_order_by_number/${this.scanNumber}?type=adjustment`)
          .then((response) => {
            if (response && response.data) {
              this.$router.push(`/adjustment_orders/${response.data}`)
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.order.noOrderFound') })
            }
          })
          .finally(() => { this.scannerFieldLoading = false })
      }
    }
  }
}
</script>
